<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline :title="title">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col class="mt-2" cols="12" sm="6">
              <label class="font-weight-medium body-2">
                Theme Name
                <span class="requir error--text">*</span>
              </label>
              <v-text-field
                counter="100"
                required
                v-model.trim="themeName"
                placeholder="Enter Theme Name"
                maxlength="100"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Class Time
                <span class="requir error--text">*</span>
                <small>(In Minutes)</small>
              </label>
              <v-text-field
                type="number"
                required
                v-model.trim="classTime"
                placeholder="Enter Class Time"
              ></v-text-field>
            </v-col>
            <v-col class="mt-2" cols="12" sm="3">
              <label class="font-weight-medium body-2">
                Select Day
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete
                key="id"
                :disabled="isDisableDaySelection"
                :items="getDayWiseValue"
                placeholder="Select Day"
                v-model="selectedDay"
                required
                item-text="name"
                item-value="name"
                :hide-details="true"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2"> Schedule Week </label>
              <div v-for="(n, i) of skill" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-text-field
                            class="my-0 py-4"
                            type="number"
                            disabled
                            min="1"
                            placeholder="Enter Position"
                            v-model.trim="skill[i].position"
                            maxlength="100"
                            :required="i === 0"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <!-- <v-text-field class="my-0 py-1" counter="100" placeholder="Enter Period"
                            :required="i === 0" v-model.trim="skill[i].period" maxlength="100">
                          </v-text-field> -->
                          <v-autocomplete
                            key="id"
                            :items="themeList"
                            placeholder="Select Theme"
                            v-model="skill[i].theme"
                            required
                            item-text="name"
                            item-value="name"
                            :hide-details="true"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            class="my-0 py-4"
                            type="number"
                            placeholder="Enter Theme Time"
                            :required="i === 0"
                            v-model.trim="skill[i].themeTime"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-text-field
                            class="my-0 py-4"
                            counter="100"
                            placeholder="Enter Title"
                            :required="i === 0"
                            v-model.trim="skill[i].title"
                            maxlength="100"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center"
                    >
                      <label class="font-weight-medium body-2"
                        >No. {{ i + 1 }}</label
                      >

                      <v-card-actions>
                        <v-btn
                          title="Delete skill"
                          elevation="1"
                          color="error"
                          @click="deleteRow(i, skill[i])"
                        >
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn
                  bottom
                  right
                  elevation="1"
                  color="primary"
                  @click="
                    skill.push({
                      position: Number(skill.length) + 1,
                      theme: '',
                      themeTime: '',
                      title: ''
                    })
                  "
                >
                  <v-icon left> mdi-plus </v-icon>
                  Add Period
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['folderId', 'dayID', 'day'],
  data () {
    return {
      name: '',
      themeName: '',
      selectedDay: '',
      isDisableDaySelection: false,
      classTime: '',
      classList: [],
      skill: [
        {
          position: 1,
          theme: '',
          themeTime: '',
          title: ''
        }
      ],
      isEdit: false,
      deleteSkill: [],
      title: 'Week at a glance',
      themeList: []
    }
  },
  created: async function () {
    this.title = this.themeAndSkillId
      ? 'Edit Week at a glance'
      : 'Add Week at a glance'
    await this.getWeekScheduleList()
    if (this.themeAndSkillId) {
      await this.getThemeAndSkillById()
    }
    await this.getThemeList()
  },
  computed: {
    getDayWiseValue () {
      let temp = []
      for (let i = 1; i <= 5; i++) {
        temp.push({ id: i, name: `DAY ${i}` })
      }
      return temp
    }
  },
  watch: {},
  methods: {
    getWeekScheduleList: async function () {
      try {
        console.log('this.id', this.dayID, this.dayID.includes('DAY'), this.day)
        if (!this.dayID || this.dayID.includes('DAY')) {
          this.getWeekDetails()
          this.selectedDay = this.dayID.split('_').join(' ')
          this.isDisableDaySelection = true
          return ''
        }

        this.isEdit = true
        this.isDisableDaySelection = true
        const { data } = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-day-at-glance/topic/${this.dayID}`
        )
        if (!data) {
          return ''
        }
        this.themeName = data.themeName
        this.classTime = data.classTime
        this.selectedDay = data.dayName
        if (data.weekDay) {
          this.skill = data.weekDay
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getWeekDetails: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-week/${this.folderId}`
        )
        res = res.data
        if (res.message === 'No schedule found!') {
          return ''
        }
        this.themeName = res.weekAtGlance[0].themeName
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    save: async function () {
      try {
        for (let item of this.skill) {
          if (
            item.position === '' ||
            item.theme === '' ||
            item.themeTime === '' ||
            item.title === ''
          ) {
            return this.errMsg('All the fields are required!')
          }
        }
        console.log('this.skill : ', this.skill)
        let formData = {
          folderMapID: this.folderId,
          themeName: this.themeName,
          classTime: this.classTime,
          dayName: this.selectedDay,
          day: this.skill
        }
        console.log('formData : ', formData)
        if (this.isEdit) {
          delete formData.folderMapID
          delete this.skill.folderMapID
        }

        if (this.isEdit) {
          let res = await http.put(
            `${CONSTANTS.API_URL}/api/curriculum_cms/update-weekschedule/${this.dayID}`,
            formData
          )
          this.okMsg(res.data)
        } else {
          let res = await http.post(
            `${CONSTANTS.API_URL}/api/curriculum_cms/create-weekschedule`,
            formData
          )
          this.okMsg(res.data)
        }

        this.$router.push({ name: 'weekScheduleList' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getThemeAndSkillById: async function () {
      try {
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-themes/${this.themeAndSkillId}`
        )
        res = res.data

        this.name = res.name
        this.skill = res.Skills
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getThemeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/getall-themes`
        )
        this.themeList = res.data.rows
        // this.themeList = res.data.rows.map((item, index) => {
        //   item.srno = this.pageSize * (this.page - 1) + index + 1
        //   item.skillName = item.Skills.map(s => s.name).join(',') || '-'
        //   return item
        // })
        this.totalPages = res.data.totalPages
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    deleteRow (e, item) {
      if (item.id) {
        this.deleteSkill.push(item.id)
      }
      if (this.skill.length > 1) {
        this.skill = _.filter(this.skill, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one skill is required!')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
